import { Box, Button, Link, Stack, Typography } from '@mui/material';
import { Trans } from 'react-i18next';

import { CaymanCountryLogoWithText } from '@/components/Icon/Logo';

import { useAppDispatch } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { signOut } from '@/redux/auth/actions';

import { getDataTestId } from '@/utils/browser';

import { StyledCaymanValidationFailedScreen } from './styles';

export default function CaymanThirdPartyComplianceCheckFailedScreen() {
  const { t } = useTranslate();
  const dispatch = useAppDispatch();
  const onBackToSignIn = () => dispatch(signOut());

  return (
    <StyledCaymanValidationFailedScreen
      {...getDataTestId('cayman-validation-personal-failed-screen')}
    >
      <Stack
        className="cayman-validation-personal-failed-screen"
        justifyContent="space-between"
        alignItems="center"
        flex={1}
        direction={'column'}
      >
        <Box>&nbsp;</Box>
        <Stack direction={'column'}>
          <CaymanCountryLogoWithText
            alt="Cayman Country Logo with Text"
            {...getDataTestId('cayman-validation-personal-failed-logo')}
          />
          <Box marginTop={8}>
            <Typography
              variant="h2"
              textAlign="center"
              mb={2}
              {...getDataTestId('cayman-validation-personal-failed-title')}
            >
              {t('createNewAccount.caymanPersonalValidationFailed.header')}
            </Typography>
            <Typography
              variant="body2"
              textAlign="center"
              mb={4}
              width={342}
              {...getDataTestId('cayman-validation-personal-failed-body')}
            >
              <Trans
                i18nKey="createNewAccount.caymanPersonalValidationFailed.body"
                components={{
                  PhoneLink: (
                    <Link
                      color="primary"
                      fontWeight="bold"
                      href="tel:345-949-8300"
                    />
                  ),
                }}
              />
            </Typography>
          </Box>
        </Stack>
        <Button
          fullWidth
          onClick={onBackToSignIn}
          variant="contained"
          {...getDataTestId('cayman-validation-personal-failed-login-button')}
        >
          {t(
            'createNewAccount.caymanPersonalValidationFailed.button.backToLogin',
          )}
        </Button>
      </Stack>
    </StyledCaymanValidationFailedScreen>
  );
}
